import { DotLegalButton, DotLegalOverflowMenu, DotLegalPageHeader, DotLegalTableWithControls, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { Box, TableCell, TableRow } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "@localization/useTranslation";
import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import useIncidentAffectedServicesHooks from "./IncidentAffectedServices.hooks";
import { IncidentAffectedService } from "./IncidentAffectedServices.types";
import AddEditIncidentAffectedServiceDialog from "../addEditIncidentAffectedServiceDialog/AddEditIncidentAffectedServiceDialog";
import TablePagePaper from "@common/components/tablePagePaper/TablePagePaper";

function IncidentAffectedServices() {
    const {
        incidentAffectedServices,
        isLoading,
        breadCrumbs,
        getMenuItems,
        onDialogClose,
        showCreateDialog,
        onSaved,
        incidentAffectedServiceForDeletion,
        setIncidentAffectedServiceForDeletion,
        onDelete,
        onCreateClick,
        canManageMasterData,
        incidentAffectedServiceForUpdate,
        isDeleting,
    } = useIncidentAffectedServicesHooks();
    const { translateString } = useTranslation();

    const headers = Array<ITableHeader<IncidentAffectedService>>();
    headers.push({ property: "name", text: translateString("name") });
    headers.push({ property: "isCustom", text: translateString("standardMasterData") });

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader
                breadCrumbs={breadCrumbs}
                rightComponent={
                    canManageMasterData ? (
                        <DotLegalButton size="medium" buttonType={"primary"} onClick={onCreateClick}>
                            {translateString("createIncidentAffectedService")}
                        </DotLegalButton>
                    ) : undefined
                }
            />
            <TablePagePaper>
                <DotLegalTableWithControls
                    internalScroll
                    headers={headers}
                    isLoading={isLoading}
                    data={incidentAffectedServices}
                    emptyText={translateString("noData")}
                    defaultOrderBy={"name"}
                    hideRowsPerPage
                    getUserSpecificPageLength={() => 100}
                    labelRowsPerPage={translateString("showEntites")}
                    labelSearch={translateString("search")}
                    noOptionsLabel={translateString("noOptions")}
                    paginationLabelOf={translateString("labelOf")}
                    clickableRows={false}
                    hasOverflowMenu
                    renderRow={(row) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>
                                <Box sx={{ height: "20px !important" }}>{!row.isCustom ? <CheckIcon sx={{ height: "20px !important" }} /> : ""}</Box>
                            </TableCell>
                            <TableCell align={"right"}>{row.isCustom && <DotLegalOverflowMenu items={getMenuItems(row)} />}</TableCell>
                        </TableRow>
                    )}
                />
            </TablePagePaper>
            {incidentAffectedServiceForDeletion && (
                <DotLegalDeleteDialogWrapper
                    open
                    onDialogClose={() => setIncidentAffectedServiceForDeletion(undefined)}
                    onOkClick={onDelete}
                    itemForDeletion={incidentAffectedServiceForDeletion.name}
                    inProgress={isDeleting}
                />
            )}
            {(showCreateDialog || incidentAffectedServiceForUpdate !== undefined) && (
                <AddEditIncidentAffectedServiceDialog
                    onDialogClose={onDialogClose}
                    incidentAffectedServiceToUpdate={incidentAffectedServiceForUpdate}
                    onSaved={onSaved}
                />
            )}
        </Box>
    );
}

export default IncidentAffectedServices;
